/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ symbol: NonNullable<unknown> }} Components_Token_Icon_View_Asset_Details_LabelInputs */

const en_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`View ${i?.symbol} asset details`)
};

const de_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Asset-Details für ${i?.symbol} anzeigen`)
};

const pt_br2_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalhes do ativo ${i?.symbol}`)
};

const tr_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} varlık ayrıntılarını görüntüle`)
};

const zh_cn2_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看 ${i?.symbol} 资产详情`)
};

const zh_hk2_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看 ${i?.symbol} asset 詳情`)
};

const ko_kr2_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.symbol} 자산 상세 보기`)
};

const ru_ru2_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть сведения об активе ${i?.symbol}`)
};

const es_419_components_token_icon_view_asset_details_label = /** @type {(inputs: Components_Token_Icon_View_Asset_Details_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalles del activo ${i?.symbol}`)
};

/**
* | output |
* | --- |
* | "View {symbol} asset details" |
*
* @param {Components_Token_Icon_View_Asset_Details_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_view_asset_details_label = /** @type {((inputs: Components_Token_Icon_View_Asset_Details_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_View_Asset_Details_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_view_asset_details_label(inputs)
	if (locale === "de") return de_components_token_icon_view_asset_details_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_view_asset_details_label(inputs)
	if (locale === "tr") return tr_components_token_icon_view_asset_details_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_view_asset_details_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_view_asset_details_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_view_asset_details_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_view_asset_details_label(inputs)
	return es_419_components_token_icon_view_asset_details_label(inputs)
});